import { API_URL } from './config';
import authProvider, { getAccessToken } from "../authProvider";

let isRefreshing = false;
let refreshPromise = null;

const fetchApi = async (url, options = {}, isPublic = false, retry = true) => {
    try {
        // Get access token from memory
        const accessToken = getAccessToken();

        // Ensure credentials are included for cookie-based auth
        const fetchOptions = {
            ...options,
            credentials: 'include', // Always send cookies with requests
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
                // Add Authorization Bearer token if available and not public
                ...(accessToken && !isPublic && { 'Authorization': `Bearer ${accessToken}` }),
            },
        };

        const response = await fetch(`${API_URL}/${url}`, fetchOptions);
        const contentType = response.headers.get("Content-Type");

        let responseData;
        if (contentType && contentType.includes("application/json")) {
            responseData = await response.json();
        } else {
            responseData = await response.text(); // Handles HTML or other types
        }

        // Handle 401 Unauthorized - access token expired
        if (response.status === 401 && !isPublic && retry) {

            // If already refreshing, wait for that promise
            if (isRefreshing) {
                await refreshPromise;
            } else {
                // Start refresh process
                isRefreshing = true;
                refreshPromise = authProvider.refreshToken()
                    .catch((error) => {
                        console.error("[fetchApi] Token refresh failed:", error);
                        // Redirect to login on refresh failure
                        window.location.href = '/user/login';
                        throw error;
                    })
                    .finally(() => {
                        isRefreshing = false;
                        refreshPromise = null;
                    });

                await refreshPromise;
            }

            // Retry the original request with new token
            return fetchApi(url, options, isPublic, false); // Don't retry again
        }

        if (!response.ok) {
            const errorMessage = responseData.message || response.statusText;
            const errorData = responseData.data || responseData.error || [];

            if(!isPublic){
                try {
                    await authProvider.checkAuth();
                } catch (authError) {
                    window.location.href = '/user/login';
                    throw { message: 'User not authenticated', data: [] };
                }
            }

            throw { message: errorMessage, data: errorData };
        }
        return responseData;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export default fetchApi;
